import Vue from 'vue'
import VueRouter from 'vue-router'

import MainLayout from "@/components/layouts/MainLayout";
import Login from '@/components/pages/authentication/Login'
import SuccessLogin from '@/components/pages/authentication/SuccessLogin'
import Overview from '@/components/pages/Overview'
import LiveMap from '@/components/pages/LiveMap'
// nanalytics pages
import Reports from '@/components/pages/analytics/Reports'
import ReportsV2 from '@/components/pages/analytics/ReportsV2.vue'
import Hitmaps from '@/components/pages/analytics/Hitmaps'
import Insights from '@/components/pages/analytics/Insights'
// affiliates pages
import Profiles from '@/components/pages/affiliates/Profiles'
import Campaigns from '@/components/pages/affiliates/Campaigns'
import AffiliateCompanyEditor from '@/components/pages/affiliates/AffiliateCampaignsEditor'
import CampaignsApprove from '@/components/pages/affiliates/CampaignsApprove'
import MassCampaigns from '@/components/pages/affiliates/MassCampaigsPage'
import Workflow from '@/components/pages/affiliates/Workflow'
// advertiser pages
import AdProfiles from '@/components/pages/advertisers/Profiles'
import Offers from '@/components/pages/advertisers/Offers'
import Applications from '@/components/pages/advertisers/Applications'
import Programs from '@/components/pages/advertisers/Programs'
import Blocking from '@/components/pages/advertisers/Blocking'
import Domains from '@/components/pages/advertisers/Domains'
import EditDomain from '@/components/pages/advertisers/EditDomain'
import EditOffer from '@/components/pages/advertisers/offers/EditOffer'
import EditOfferV2 from '@/components/pages/advertisers/offers/EditOfferV2'
import EditAdvertiser from '@/components/pages/advertisers/EditAdvertiser.vue'
import EditAggregatedOffer from '@/components/pages/advertisers/offers/EditAggregatedOffer'
import EditProgram from '@/components/pages/advertisers/programs/EditProgram'
import InvoicesApprove from '@/components/pages/advertisers/InvoicesApprove'
import PixelLog from "../components/pages/advertisers/PixelLog"
import RagAnswer from "../components/pages/rag/RagAnswer.vue"

import Finance from '@/components/pages/finance/Finance.vue'
import Invoicing from '@/components/pages/finance/Invoicing.vue'
import NotFound from '@/components/pages/NotFound'
import Forbidden from '@/components/pages/Forbidden'

import permissionGuard from "@/router/permissionGuard";
import CustomAssets from "@/components/pages/affiliates/customAssets/CustomAssets.vue";
import CustomAssetsHistory from "@/components/pages/affiliates/customAssets/CustomAssetsHistory.vue";
import AccountManagers from "@/components/pages/managers/accountManagers.vue";
import AccountManagersHistory from "@/components/pages/managers/accountManagersHistory.vue";
import AffiliateAlerts from "@/components/pages/affiliates/affiliateAlerts/affiliateAlerts.vue";
import AffiliateNews from "@/components/pages/affiliates/affiliateNews/affiliateNews.vue";
import AffiliatesAlertsHistory from "@/components/pages/affiliates/affiliateAlerts/AffiliateAlertsHistory.vue";
import AffiliatesNewsHistory from "@/components/pages/affiliates/affiliateNews/AffiliateNewsHistory.vue";


Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/successLogin/:token',
    component: SuccessLogin,
  },
  {
    path: '/errorlogin/:email',
    component: Login,
  },
  {
    path: '',
    name: '',
    component: MainLayout,
    meta: {
      checkPermissions: true,
    },
    children: [
      {
        path: '',
        name: 'Overview',
        component: Overview,
      },
      {
        path: '/livemap',
        name: 'LiveMap',
        component: LiveMap
      },
      {
        path: '/analytics/reports',
        name: 'Reports',
        component: Reports,
        props: { version: 'V1' }
      },
      {
        path: '/analytics/reports/:type',
        name: 'ReportsType',
        component: Reports,
        props: { version: 'V1' }
      },
      {
        path: '/analytics/reportsV3',
        name: 'Reports',
        component: Reports,
        props: { version: 'V3' }
      },
      {
        path: '/analytics/reportsV3/:type',
        name: 'ReportsType',
        component: Reports,
        props: { version: 'V3' }
      },
      {
        path: '/analytics/reportsV4',
        name: 'Reports',
        component: Reports,
        props: { version: 'V4' }
      },
      {
        path: '/analytics/reportsV4/:type',
        name: 'ReportsType',
        component: Reports,
        props: { version: 'V4' }
      },
      // {
      //   path: '/analytics/reportsV2/:type',
      //   name: 'ReportsType',
      //   component: Reports
      // },
      {
        path: '/analytics/reportsV2',
        name: 'ReportsType',
        component: ReportsV2
      },
      {
        path: '/analytics/reportsV2/:type',
        name: 'ReportsType',
        component: ReportsV2
      },
      {
        path: '/analytics/rag',
        name: 'RagAssistant',
        component: RagAnswer
      },
      {
        path: '/analytics/hitmaps',
        name: 'Hitmaps',
        component: Hitmaps
      },
      {
        path: '/analytics/insights',
        name: 'Insights',
        component: Insights
      },
      {
        path: '/affiliates/profiles',
        name: 'Profiles',
        component: Profiles
      },
      {
        path: '/affiliates/campaigns',
        name: 'Campaigns',
        component: Campaigns
      },
      {
        path: '/affiliates/massManageAffiliatePID',
        name: 'affiliateCampaignsEditor',
        component: AffiliateCompanyEditor
      },
      {
        path: '/affiliates/multipleCampaignsCreation/:step',
        name: 'multipleCampaignsCreation',
        component: MassCampaigns
      },
      {
        path: '/affiliates/customAssets',
        name: 'customAssets',
        component: CustomAssets
      },
      {
        path: '/affiliates/alerts',
        name: 'affiliateAlerts',
        component: AffiliateAlerts
      },
      {
        path: '/affiliates/news',
        name: 'affiliateNews',
        component: AffiliateNews
      },
      {
        path: '/affiliates/news/history/:id',
        name: 'AffiliatesNewsHistory',
        component: AffiliatesNewsHistory
      },
      {
        path: '/affiliates/alerts/history/:id',
        name: 'AffiliatesAlertsHistory',
        component: AffiliatesAlertsHistory
      },
      {
        path: '/affiliates/customAssets/history/:id',
        name: 'CustomAssetsHistory',
        component: CustomAssetsHistory
      },
      {
        path: '/affiliates/campaignsApprove',
        name: 'CampaignsApprove',
        component: CampaignsApprove
      },
      {
        path: '/affiliates/workflow',
        name: 'Workflow',
        component: Workflow
      },
      {
        path: '/advertisers/profiles',
        name: 'AdProfiles',
        component: AdProfiles
      },
      {
        path: '/advertisers/offers',
        name: 'Offers',
        component: Offers
      },
      {
        path: '/advertisers/applications',
        name: 'Applications',
        component: Applications
      },
      {
        path: '/advertisers/programs',
        name: 'OffersPrograms',
        component: Programs
      },
      {
        path: '/advertisers/blocking',
        name: 'OffersBlocking',
        component: Blocking
      },
      {
        path: '/advertisers/programs/edit/:id',
        name: 'EditProgram',
        component: EditProgram
      },
      {
        path: '/advertisers/programs/create/:id',
        name: 'CreateProgramBy',
        component: EditProgram
      },
      {
        path: '/advertisers/programs/create',
        name: 'CreateProgram',
        component: EditProgram
      },
      {
        path: '/advertisers/offerV2/:id',
        name: 'editOfferV2',
        component: EditOfferV2
      },
      {
        path: '/advertisers/offer/:id',
        name: 'editOffer',
        component: EditOffer
      },
      {
        path: '/advertiser/:id',
        name: 'editAdvertiser',
        component: EditAdvertiser
      },
      {
        path: '/advertisers/aggregatedOffer/:id',
        name: 'editAggregatedOffer',
        component: EditAggregatedOffer
      },
      {
        path: '/advertisers/domains',
        name: 'Domains',
        component: Domains
      },
      {
        path: '/advertisers/domain/:domain_id',
        name: 'editDomain',
        component: EditDomain
      },
      {
        path: '/advertisers/invoicesApprove',
        name: 'InvoicesApprove',
        component: InvoicesApprove
      },
      {
        path: '/advertisers/pixelLog',
        name: 'PixelLog',
        component: PixelLog
      },
      {
        path: '/finance',
        name: 'Finance',
        component: Finance
      },
      {
        path: '/finance/invoicing',
        name: 'Invoicing',
        component: Invoicing
      },
      {
        path: '/managers/accountManagers',
        name: 'AccountManagers',
        component: AccountManagers
      },
      {
        path: '/managers/accountManager/history/:id',
        name: 'ManagersHistory',
        component: AccountManagersHistory
      },
      {
        path: '/403',
        name: '403',
        component: Forbidden
      },
    ]
  },
  {
    path: '/404',
    name: '404',
    component: NotFound
  },
  {
    path: '*',
    name: '404',
    component: NotFound
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach(permissionGuard);

export default router
